import React from 'react'
import HeaderInner from '../header/HeaderInner';
import ProjectMesonary from './breadcrumb/ProjectMesonary';
import Footer from '../elements/Footer';
import PortfolioSeven from '../elements/PortfolioSeven';
import { Link } from 'react-router-dom';



function Appoinment() {
  return (
    <div className='service-details'>
        <div className="">
            <HeaderInner/>
            <main>
                <ProjectMesonary/>
                <PortfolioSeven/>
                <Footer/>
            </main>
        </div>
    </div>
  )
}

export default Appoinment